import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { ILoginlogTable, ILoginlogTableRedux, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import { DateRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faUserCog, faPen, faPhone, faTrash, faEye, faLaptop, faMobileAlt, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';

const LoginlogTable = ({ 
  loginlogsData,
 }: ILoginlogTable) => {
  const [modal, setModal] = useState(false);
  const history = useHistory();

  const alert = useAlert();

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        hidden: true
      },
      {
        Header: "Propriétaire",
        accessor: "login",
        Cell: ({ value, row: { original } }) => {
          return (<a href={original.user_id !== null && original.user_id !== undefined ? (`/gestion_utilisateur/${original.user_id}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(original.user_id !== null && original.user_id !== undefined){
              if (e.ctrlKey){
                window.open('/gestion_utilisateur/' + original.user_id,'_blank');
                return;
              }
              history.push({ pathname: `/gestion_utilisateur/${original.user_id}` })
            }
            else
              alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
          }}><button className="openLinkBtn" title={original.user?.given_name || original.user?.surname ? `${original.user?.surname || ""} ${original.user?.given_name || ""}` : ""}>{value || "-"}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        }
      },
      {
        Header: "ID Appareil",
        accessor: "token_id",
        hidden: true
      },
      {
        Header: "MDP. correct",
        accessor: (row, index) => row.wrong_password === 0 ? "Oui" : row.wrong_password === 1 ? "Non" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-",
      },
      {
        Header: "Était autorisé",
        accessor: (row, index) => row.was_allowed === 1 ? "Oui" : row.was_allowed === 0 ? "Non" : "",
        // accessor: "was_allowed",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-",
        // Cell: ({ value }) => value === 1 ? "Oui" : value === 0 ? "Non" : "-",
      },
      {
        Header: "USER AGENT",
        accessor: "user_agent",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Appareil",
        accessor: (row, index) => row.on_computer === 1 ? "Ordinateur" : row.on_computer === 0 ? "Téléphone" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ row: {original} }) => original.on_computer === 1 ? <FontAwesomeIcon icon={faLaptop} title="Ordinateur" style={{fontSize: "x-large"}} /> : original.on_computer === 0 ? <FontAwesomeIcon icon={faMobileAlt} title="Téléphone" style={{fontSize: "x-large"}} /> : "-",
        // Cell: ({ value }) => value === 1 ? <FontAwesomeIcon icon={faLaptop} title="Ordinateur" style={{fontSize: "x-large"}} /> : value === 0 ? <FontAwesomeIcon icon={faMobileAlt} title="Téléphone" style={{fontSize: "x-large"}} /> : "-",
      },
      {
        Header: "Navigateur",
        accessor: "browser",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Résolution",
        accessor: "screen",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Date",
        accessor: "createdAt",
        customExportDisplay: `$.createdAt ? new Date($.createdAt).toLocaleString('fr') : ""`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-"
      }
    ],
    []
  );

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={loginlogsData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: ILoginlogTableRedux) => ({
});

export default connect(mapStateToProps, {})(LoginlogTable);
